// OpenDefaultInpFileHeadless.tsx
import { useEffect } from "react"
import { SwmmConvert } from "@fileops/swmm-node"
import "../../css/index.css"

/**
 * 
 * @param {function} setModel sets the swmm model in JSON format
 * @param {string} fileName the path and name of an epa-swmm file
 * @param {function} setSwmmTxt sets the swmm model .inp file contents in string format
 * @param {function} setSwmmOut sets the swmm .out file contents
 * @param {function} setRpt sets the .rpt file contents in string format
 * @param {function} setLoadModel sets loadModel flag, signals to other components that a new model has been loaded and old results invalidated.
 * @param {function} closeAll closes all dialogs that relate input and output for the model and interface.
 * @returns null. This is rebuilt from a headed component and should recieve more refactoring.
 */
const OpenDefaultInpFileHeadless = ({setModel, fileName, setSwmmTxt, setSwmmOut, setRpt, setLoadModel, closeAll, reloadFile}) => {
  async function showFile () {
    // Read the input file
    fetch(fileName)
      .then((r)=>r.text())
      .then(text =>{
        let jsonSWMM = SwmmConvert.parseInput(text)// If there isn't a PCS and TRANSFORM section in the file, add them
        if(jsonSWMM.PCS == null){
          jsonSWMM.PCS = {
            swmmNode_proj: {
                "proj": "utm",
                "zone": "0",
                "datum": "WGS84",
                "units": "ft",
                "defs": "no_defs"
            }
          }
        }
        if( jsonSWMM.TRANSFORM == null ){
          jsonSWMM.TRANSFORM = {
            swmmNode_t: {
              "x": 0,
              "y": 0,
              "size": 1,
              "rotation": 0
            }
          }
        }
        if(jsonSWMM.MAP == null){
          jsonSWMM.MAP = {
            "DIMENSIONS": {
                "x1": 0,
                "y1": 0,
                "x2": 10000,
                "y2": 10000
            },
            "Units": "None"
          }
        }
        setSwmmTxt(text)
        setModel(jsonSWMM)
        setLoadModel(prev=>prev+1)
      })
  }

  useEffect(()=>{
    closeAll()
    if(reloadFile > 0){
      setSwmmOut(undefined)
      setRpt('')
    }
    showFile()
  }, [fileName])

  return(null)
}
 
export {OpenDefaultInpFileHeadless}